import { ActionType } from "models/messagemanagement/deleteMessage";

export const deleteMessageAction = (payload: any) => {
  return {
    type: ActionType.DELETE_MESSAGE,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.DELETE_MESSAGE_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: any) => {
  return {
    type: ActionType.DELETE_MESSAGE_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.RESET_DELETE_MESSAGE,
  };
};
